<template>
  <div class="workflow-form">
    <baseFrame
      save-text=""
      cancel-text=""
      clear-text=""
      submit-text="">
      <div slot="content">
        <lk-card class="mb16" title="门店统计信息">
          <div class="summary">
            <div class="summary-item">
              <DownloadButton text="导出全部" @on-click="getStatisticsDetailAllExport" v-if="handlePermission('statisticsViewDetailAllExcel')"></DownloadButton>
            </div>
            <div class="summary-item">门店名称:{{queryStr.storeName}}</div>
            <div class="summary-item" v-if="queryStr.nameMix">商品搜索: {{queryStr.nameMix}}</div>
            <div class="summary-item" v-if="queryStr.epSourceType">来源类型: {{queryStr.epSourceType}}</div>
            <div class="summary-item" v-if="queryStr.epCreatorType">ID类型: {{queryStr.epCreatorType}}</div>
            <div class="summary-item" v-if="queryStr.epCreatorId">来源姓名: {{queryStr.epCreatorId}}</div>
          </div>
          <div class="summary">
            <div class="summary-item">
              <lk-select
                @on-change="handleChangeDate"
                class="item"
                v-model="query.year"
                filterable>
                <lk-option v-for="item in years" :key="item" :value="item">{{item}}年</lk-option>
              </lk-select>
            </div>
            <div class="summary-item" v-show="type === '2'">
              <lk-select
                @on-change="handleChangeDate"
                v-model="query.month"
                style="width: 80px;">
                <lk-option v-for="item in 12" :value="item" :key="item">{{item}}月</lk-option>
              </lk-select>
            </div>

            <div class="summary-item">当{{getTypeName}}销量(万元)/上{{getTypeName}}销量(万元)：<span class="summary-item-value">{{summaryInfo.amountStr || 0 }} / {{summaryInfo.lastAmountStr || 0 }}</span></div>
            <div class="summary-item">DTP当{{getTypeName}}销量(万元)/DTP上{{getTypeName}}销量(万元)：<span class="summary-item-value">{{summaryInfo.dtpAmountStr || 0 }} / {{summaryInfo.dtpLastAmountStr || 0 }}</span></div>
          </div>
          <div class="summary">
            <div class="summary-item">
              <DownloadButton text="导出查询结果" @on-click="getStatisticsDetailExport" v-if="handlePermission('statisticsViewDetailQueryExcel')"></DownloadButton>
            </div>
          </div>
          <barChart id="chart-bar" :xData="xData" :yData="yData" height="280px"></barChart>
          <lk-table border :columns="columns" :data="tableData"></lk-table>
        </lk-card>

      </div>
    </baseFrame>
  </div>
</template>
<script>
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import reportService from '../../services/report';
import DownloadButton from '../../components/download/DownloadButton';
import baseFrame from '../../components/frame/BaseFrame.vue';
import barChart from '../../components/charts/Bar.vue';

export default {
  name: 'StatisticsViewDetail',
  mixins: [mapState],
  components: {
    baseFrame,
    DownloadButton,
    barChart,
  },
  data() {
    return {
      query: {
        year: new Date().getFullYear(),
        month: 1,
        storeId: null,
      },
      summaryInfo: {},
      years: [],
      xData: [],
      yData: [],
      columns: [
        {
          title: '月份',
          key: 'month',
          minWidth: 116,
        },
        {
          title: '毛利率(%)',
          key: 'profitRateStr',
          minWidth: 116,
        },
        {
          title: '当月销量(万元)',
          key: 'amountOfTheMonthStr',
          minWidth: 116,
        },
        {
          title: '环比(%)',
          key: 'chainRatioStr',
          minWidth: 116,
          render: (h, { row }) => {
            const chainRatio = parseFloat(row.chainRatioStr);
            const flag = chainRatio < 0;
            return h('div', {
              class: {
                red: flag, // 负数变红
              },
            }, [
              h('span', row.chainRatioStr),
              chainRatio !== 0 ? h('lk-icon', {
                props: {
                  type: flag ? 'md-arrow-round-down' : 'md-arrow-round-up',
                  size: 14,
                },
              }) : null,
            ]);
          },
        },
        {
          title: '同比(%)',
          key: 'periodRatioStr',
          minWidth: 116,
          render: (h, { row }) => {
            const periodRatio = parseFloat(row.periodRatioStr);
            const flag = periodRatio < 0;
            return h('div', {
              class: {
                red: flag, // 负数变红
              },
            }, [
              h('span', row.periodRatioStr),
              periodRatio !== 0 ? h('lk-icon', {
                props: {
                  type: flag ? 'md-arrow-round-down' : 'md-arrow-round-up',
                  size: 14,
                },
              }) : null,
            ]);
          },
        },
        {
          title: 'DTP毛利率',
          key: 'dtpProfitRateStr',
          minWidth: 116,
        },
        {
          title: 'DTP当月销量(万元)',
          key: 'dtpAmountOfTheMonthStr',
          minWidth: 116,
        },
        {
          title: 'DTP环比(%)',
          key: 'dtpChainRatioStr',
          minWidth: 116,
          render: (h, { row }) => {
            const chainRatio = parseFloat(row.dtpChainRatioStr);
            const flag = chainRatio < 0;
            return h('div', {
              class: {
                red: flag, // 负数变红
              },
            }, [
              h('span', row.dtpChainRatioStr),
              chainRatio !== 0 ? h('lk-icon', {
                props: {
                  type: flag ? 'md-arrow-round-down' : 'md-arrow-round-up',
                  size: 14,
                },
              }) : null,
            ]);
          },
        },
        {
          title: 'DTP同比(%)',
          key: 'dtpPeriodRatioStr',
          minWidth: 116,
          render: (h, { row }) => {
            const chainRatio = parseFloat(row.dtpPeriodRatioStr);
            const flag = chainRatio < 0;
            return h('div', {
              class: {
                red: flag, // 负数变红
              },
            }, [
              h('span', row.dtpPeriodRatioStr),
              chainRatio !== 0 ? h('lk-icon', {
                props: {
                  type: flag ? 'md-arrow-round-down' : 'md-arrow-round-up',
                  size: 14,
                },
              }) : null,
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  computed: {
    getTypeName() {
      return this.type === '1' ? '年' : '月';
    },
  },
  methods: {
    getData() {
      reportService.getStatisticsViewDetail(this.query).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          this.formatChartData(data);
          this.tableData = data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getSummaryInfo() {
      const finalFn = this.type === '1' ? reportService.getStatisticsYearTotal : reportService.getStatisticsMonthTotal;
      finalFn(this.query).then((res) => {
        if (res.data.status === 200) {
          this.summaryInfo = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleChangeDate() {
      this.getData();
      this.getSummaryInfo();
    },
    getStatisticsDetailExport() {
      const params = utils.deepClone(this.query);
      params.queryCondition = this.getQueryCondition();
      reportService.getStatisticsDetailExport(this.query).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getQueryCondition(isAll) {
      const queryConditions = [];
      queryConditions.push(`门店名称:${this.queryStr.storeName}`);
      if (isAll) {
        const years = (new Date().getFullYear() - 2017);
        const yearList = this.getNearYears(years + 1, false);
        queryConditions.push(`年份:${yearList.join('、')}年`);
      } else {
        queryConditions.push(`年份:${this.query.year}年`);
      }
      if (this.type === '2') {
        queryConditions.push(`月份:${this.query.month}月`);
      }
      return queryConditions.join(';');
    },
    getStatisticsDetailAllExport() {
      const params = utils.deepClone(this.query);
      const years = (new Date().getFullYear() - 2017);
      params.queryCondition = this.getQueryCondition(true);
      params.yearList = this.getNearYears(years + 1, false);
      delete params.year;

      reportService.getStatisticsDetailAllExport(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getNearYears(num, flag = true) {
      const arr = [];
      const oDate = new Date();
      const payload = flag ? 1 : -1;
      for (let i = 0; i < num; i++) {
        if (i === 0) {
          arr.push(oDate.getFullYear());
        } else {
          oDate.setFullYear(oDate.getFullYear() + payload);
          arr.push(oDate.getFullYear());
        }
      }
      return arr;
    },
    formatChartData(list) {
      // const chartData = {};
      const chartData = {
        currentAmount: [], // 当年|月销售
        lastAmount: [], // 上年|月销售
        dtpCurrentAmount: [], // DTP当年|月销售
        dtpLastAmount: [], // DTP上年|月销售
      };
      const storeNameList = [];
      list.forEach((item) => {
        storeNameList.push(item.month);
        chartData.currentAmount.push(this.getScale(item.amountOfTheMonth) || 0);
        chartData.lastAmount.push(this.getScale(item.amountOfTheLastMonth) || 0);
        chartData.dtpCurrentAmount.push(this.getScale(item.dtpAmountOfTheMonth) || 0);
        chartData.dtpLastAmount.push(this.getScale(item.dtpAmountOfTheLastMonth) || 0);
      });
      this.yData = [
        // 每个月展示上年同期销量、DTP上年同期销量、当月销量、DTP当月销量（下图为例图）
        {
          name: '上年同期销量',
          value: chartData.lastAmount,
        },
        {
          name: 'DTP上年同期销量',
          value: chartData.dtpLastAmount,
        },
        {
          name: '当月销量',
          value: chartData.currentAmount,
        },
        {
          name: 'DTP当月销量',
          value: chartData.dtpCurrentAmount,
        },
      ];
      this.xData = storeNameList;
    },
    getScale(value, iScale = 10000) {
      return utils.toFixed2(value / iScale, 4, 0);
    },
  },
  created() {
    const params = this.$route.params;
    this.years = this.getNearYears(4, false);
    this.query = JSON.parse(decodeURI(params.data));
    this.queryStr = JSON.parse(decodeURI(params.dataStr));
    this.type = (this.query.year && this.query.month) ? '2' : '1'; // 1年 2月
    this.query.year = Number(this.query.year) || this.query.year;
    // this.query.month = Number(this.query.month) || this.query.month;
    if (this.type === '1') {
      delete this.query.month;
    }

    if (this.query.storeId) {
      this.getData();
      this.getSummaryInfo();
    }
  },
};
</script>
<style lang="less" scoped>
  .summary {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    .summary-title {
      margin-right: 16px;
    }
    .summary-item {
      display: flex;
      margin-right: 16px;
      line-height: 24px;
      .summary-item-value {
        min-width: 20px;
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
</style>
